import React from 'react';
import { motion } from 'framer-motion';
import { UtensilsCrossedIcon, ClockIcon } from 'lucide-react';
export function KitchenClosedBanner() {
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    type: 'spring',
    damping: 20
  }} className="fixed bottom-0 left-0 right-0 z-50 max-w-md mx-auto px-3 pb-3" data-id="element-978">
      <div className="bg-surface border border-red-500/20 rounded-2xl p-4 shadow-2xl shadow-black/40" data-id="element-979">
        <div className="flex items-center gap-3" data-id="element-980">
          <div className="w-11 h-11 bg-red-500/10 rounded-full flex items-center justify-center flex-shrink-0 border border-red-500/20" data-id="element-981">
            <UtensilsCrossedIcon className="w-5 h-5 text-red-400" data-id="element-982" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-983">
            <p className="text-white text-sm font-semibold leading-tight" data-id="element-984">
              Cocina cerrada
            </p>
            <p className="text-gray-500 text-xs mt-0.5" data-id="element-985">
              No se aceptan pedidos en este momento
            </p>
          </div>
          <div className="flex items-center gap-1.5 bg-surface-light px-2.5 py-1.5 rounded-lg border border-gray-700 flex-shrink-0" data-id="element-986">
            <ClockIcon className="w-3.5 h-3.5 text-dorado" data-id="element-987" />
            <span className="text-xs text-gray-400 font-medium" data-id="element-988">5 min</span>
          </div>
        </div>
      </div>
    </motion.div>;
}